import { __decorate } from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
let HeaderUZ = class HeaderUZ extends Vue {
    customer;
    company;
};
__decorate([
    Prop({})
], HeaderUZ.prototype, "customer", void 0);
__decorate([
    Prop({})
], HeaderUZ.prototype, "company", void 0);
HeaderUZ = __decorate([
    Component({})
], HeaderUZ);
export default HeaderUZ;
